module.exports = __webpack_public_path__ + "img/hudong 2.d8d99edc.png";